import { useState } from 'react';

export default function NewsletterCTA() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');

    try {
      await new Promise(r => setTimeout(r, 800));
      setStatus('success');
      setEmail('');
    } catch {
      setStatus('error');
      setErrorMsg('Something went wrong. Please try again.');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 max-w-2xl mx-auto leading-tight">
          Stories that matter, delivered to your inbox
        </h2>
        <p className="mt-4 md:mt-5 text-sm md:text-base text-foreground-500 max-w-lg mx-auto leading-relaxed">
          Join 120,000+ readers who get our weekly digest of in-depth journalism every Sunday morning.
        </p>

        {status === 'success' ? (
          <div className="mt-8 md:mt-10 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-100 text-primary-700 text-sm font-medium">
            <i className="ri-check-line"></i>
            Welcome aboard! Check your inbox.
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="w-full sm:flex-1 px-5 py-3 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full sm:w-auto px-6 py-3 rounded-full bg-primary-600 hover:bg-primary-700 text-background-50 text-sm font-label font-medium whitespace-nowrap transition-colors cursor-pointer disabled:opacity-60 flex items-center justify-center gap-2"
            >
              {status === 'loading' ? (
                <span>Sending...</span>
              ) : (
                <>
                  Subscribe
                  <i className="ri-arrow-right-line"></i>
                </>
              )}
            </button>
          </form>
        )}
        {status === 'error' && (
          <p className="mt-3 text-xs text-accent-600">{errorMsg}</p>
        )}

        <div className="mt-12 md:mt-16">
          <div className="flex items-center justify-center gap-6 md:gap-10 flex-wrap">
            {['The Atlantic', 'Wired', 'New York Times', 'The Guardian', 'MIT Review'].map((name) => (
              <span key={name} className="text-sm text-foreground-300 font-heading italic opacity-60">
                {name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}